import { Component, OnDestroy, OnInit } from "@angular/core";

import { AuthService } from "../../services/auth/auth.service";
import { Router } from "@angular/router";
import { ProfileService } from "../../services/profile-service/profile.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
    selector: "pa-landing-page",
    templateUrl: "./landing-page.component.html",
    styleUrls: ["./landing-page.component.scss"],
    standalone: false
})
export class LandingPageComponent implements OnInit, OnDestroy {
  showBrandAcct = false;
  showMrc = false;
  showRecommit = false;

  private onDestroy$ = new Subject<void>();

  constructor(
    private auth: AuthService,
    private router: Router,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.profileService
      .getUserRoles()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((rolesRes) => {
        if (rolesRes) {
          this.showBrandAcct =
            rolesRes.indexOf("AppManager") > -1 ||
            rolesRes.indexOf("AppOwner") > -1;
          this.showMrc = rolesRes.indexOf("MRCAdmin") > -1;
          this.showRecommit = rolesRes.indexOf("RecommitUser") > -1;
        }
      });
  }

  login() {
    this.auth.login();
  }

  logout() {
    this.auth.logout();
  }

  navigateToPermission() {
    this.router.navigate(["permission"]);
  }
  navigateToBrandAccount() {
    this.router.navigate(["brand-account"]);
  }
  navigateToRecommitProcess() {
    this.router.navigate(["recommit-process"]);
  }
  navigateToMrc() {
    this.router.navigate(["mrc"]);
  }
  navigateToEdit() {
    this.router.navigate(["edit-content"]);
  }
  navigateToRewards() {
    this.router.navigate(["rewards-permission"]);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
